"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Unstable_LicenseInfoProvider", {
  enumerable: true,
  get: function () {
    return _LicenseInfoProvider.LicenseInfoProvider;
  }
});
var _LicenseInfoProvider = require("./LicenseInfoProvider");